import { createContext, type Dispatch } from 'react';

import type { FilterFieldReducerAction } from '../state/filter-field-state-reducer.js';
import type {
  FilterFieldSuggestion,
  FilterFieldSuggestionProps,
} from '../suggestions/Suggestion.js';

/** @internal */
export interface FilterFieldAutoSuggestionsContextProps {
  trailing?: string;
  suggestions?: FilterFieldSuggestion[];
}

/** @internal */
export interface FilterFieldContextProps {
  applySuggestion: (
    value: string,
    trailing: string | undefined,
    insertionStrategy: FilterFieldSuggestionProps['insertionStrategy'],
    cursorBeforeTrailing: boolean | undefined,
  ) => void;
  dispatch: Dispatch<FilterFieldReducerAction>;
  focusedSuggestion?: string;
  filterFieldId?: string;
  term?: string;
  autoSuggestions: FilterFieldAutoSuggestionsContextProps;
  triggerRef: HTMLElement | null;
}

/** @internal */
export const FilterFieldContext = createContext<FilterFieldContextProps>({
  applySuggestion: () => null,
  dispatch: () => null,
  autoSuggestions: {},
  triggerRef: null,
});
